import React from 'react';
import { Button } from './ui/button';

const About = () => {
  return (
    <section id="about" className="py-24 bg-gradient-to-br from-blue-50 to-cyan-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="order-2 lg:order-1">
            <div className="relative">
              <div className="absolute -inset-4 bg-gradient-to-r from-blue-200 to-cyan-200 rounded-3xl blur-2xl opacity-30" />
              <img 
                src="https://images.unsplash.com/photo-1522071820081-009f0129c71c?w=1200&h=800&fit=crop"
                alt="Fintage Team"
                className="relative rounded-3xl shadow-2xl w-full h-auto"
              />
            </div>
          </div>

          {/* Content */}
          <div className="order-1 lg:order-2">
            <div className="mb-6">
              <h2 className="text-4xl md:text-5xl font-bold mb-2 text-gray-900">
                Fintage
              </h2>
            </div>
            
            <p className="text-lg text-gray-700 leading-relaxed mb-6">
              Fintage is a financial technology company delivering enterprise-grade platforms for banks and financial institutions. It provides integrated solutions across regulatory compliance, payments, investments, reconciliations and core banking operations.
            </p>

            <p className="text-lg text-gray-700 leading-relaxed mb-8">
              Built on a CBS-agnostic and metadata-driven architecture, Fintage enables automation, real-time control and audit-grade transparency.
            </p>

            <Button 
              size="lg"
              className="bg-gradient-to-r from-blue-500 to-blue-600 hover:from-blue-600 hover:to-blue-700 text-white"
              onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth', block: 'start' })}
            >
              Contact Us
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;